import { render } from "./Update.vue?vue&type=template&id=286b1492&scoped=true"
import script from "./Update.vue?vue&type=script&lang=js"
export * from "./Update.vue?vue&type=script&lang=js"

import "./Update.vue?vue&type=style&index=0&id=286b1492&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286b1492"]])

export default __exports__